import React, {useState, useEffect, useLayoutEffect} from "react";

const time2string = (t) => {
	if ( typeof t === 'string') return t;
	if ( typeof t !== 'number') return undefined;
	return String(Math.floor(t/60)).padStart(2,'0')+':'+String(t % 60).padStart(2,'0');
};

const time2int = (s,step) => {
	if ( !s || typeof s !== 'string') return undefined;
	const p = s.split(":").map( x => parseInt(x));
	let x = 60 * p[0] + p[1];
	if ( step && typeof step === 'number' ) x = Math.round( x / step) * step;
	return x;
};

const SelectTime = (props) => {
	//if (typeof props === 'undefined' ) props = {};
	const [value,setValue] = useState(props.value||"");
	const [after,setAfter] = useState( props.after || false);
	const [date,setDate] = useState();
	const [uid] = useState("SelectTime-"+window.glob.generateUid());

	useLayoutEffect( ()=>{
		if ( props.globPrefix ) {
			if ( props.deps ) {
				if ( props.deps.date ) {
					window.glob.register(props.globPrefix+'changed.'+props.deps.date,(v)=> {
						setDate(v);
						setAfter(false);
					}, uid );
				}
				if (props.deps.after ) {
					window.glob.register(props.globPrefix+'changed.'+props.deps.after,(v)=> {
						setAfter(v);
						if ( value ) setTimeout( ()=>{ onchange( value, 1 ); },0);
					}, uid );
				}
			}
		}
		return ( ()=>{
			if ( props.globPrefix ) {
				if ( props.deps ) {
					if ( props.deps.date ) {
						window.glob.unregister(props.globPrefix+'changed.'+props.deps.date, uid );
					}
					if ( props.deps.after ) {
						window.glob.unregister(props.globPrefix+'changed.'+props.deps.after, uid );
					}
				}
			}
		});
	},[]);

	const validate = ( v, delay ) => {
		let min = time2int(after||props.min);
		if ( after  ) min += props.step||5;
		let max = time2int(props.max);
		let x = time2int(v,props.step||5);
		if ( x < min ) x = min;
		else if ( x > max ) x = max;
		x = time2string(x);
		if ( v && x && v !== x ) {
			setTimeout( ()=>{ setValue(x); },delay||2000);
		} else if ( value !== x ) {
			setValue(x);
		}
		return x;
	};

	const onchange = (evt,delay) => {
		if ( props.globPrefix && props.name ) {
			const v0 = typeof evt === 'string' ? evt : evt.target.value;
			const v = validate( v0, delay );
			window.glob.trigger(
				props.globPrefix+'changed',
				{ name: props.name, value: v }
			);
		}
	}

	if ( props.globPrefix && props.deps ) {
		if ( props.deps.date && props.deps.after ) {
			if ( ! date ) return <p className={"comment"}>Scegli prima data e ora iniziale.</p>;
			if ( ! after ) return <p className={"comment"}>Scegli prima l’ora iniziale.</p>;
		} else if ( props.deps.date ) {
			if ( ! date ) return <p className={"comment"}>Scegli prima la data.</p>;
		} else if ( props.deps.after ) {
			if ( ! after ) return <p className={"comment"}>Scegli prima l’ora iniziale.</p>;
		}
	}

	return (
		<input
			id={uid}
			type={"time"}
			autoFocus={props.autoFocus}
			value={value ?? ""}
			required={props.required}
			min={after||props.min}
			max={props.max}
			style={{width:"100%"}}
			step={(props.step||5)*60}
			className={"form-control"}
			onChange={onchange}
		/>
	);

};

export default SelectTime;